import ProviderService from "../../../../../../services/ProviderService";
import {
  isSet,
  optionsToKeyValuePairs,
} from "../../../../../../utils/commonUtils";
import {
  getTbBloodPatientQuestionnaireCardSections,
  tbQuestionnaireFormDefaults,
} from "./tbBloodQuestionnaire";

export const MobileHealthTB = (props, type = "Others") => {
  const physicalExamination = [
    { label: "General", name: "general", notesName: "general_notes" },
    {
      label: "Respiratory",
      name: "respiratory",
      notesName: "respiratory_notes",
    },
    {
      label: "Cardiovascular",
      name: "cardiovascular",
      notesName: "cardiovascular_notes",
    },
    {
      label: "Gastrointestinal",
      name: "gastrointestinal",
      notesName: "gastrointestinal_notes",
    },
    { label: "Urinary", name: "urinary", notesName: "urinary_notes" },
    {
      label: "Musculoskeletal",
      name: "musculoskeletal",
      notesName: "musculoskeletal_notes",
    },
    {
      label: "Neurological",
      name: "neurological",
      notesName: "neurological_notes",
    },
    { label: "Skin", name: "skin", notesName: "skin_notes" },
    { label: "Endocrine", name: "endocrine", notesName: "endocrine_notes" },
    { label: "Hematology", name: "hematology", notesName: "hematology_notes" },
    {
      label: "Allergy / Immunology",
      name: "allergy_immunology",
      notesName: "allergy_immunology_notes",
    },
    {
      label: "Psychiatric",
      name: "psychiatric",
      notesName: "psychiatric_notes",
    },
  ];

  const clinicianQuestions = [
    {
      label: "1. Does the individual report TB-like symptoms?",
      name: "clinician_tb_like_symptoms",
    },
    {
      label: "2.Does the individual identify TB risk factors?",
      name: "clinician_tb_risk_factors",
    },
    {
      label:
        "3. Does the individual have medical conditions related to immunosuppression?",
      name: "clinician_medical_conditions",
    },
  ];

  const charts = [
    props.hasEditAccess
    ? {
        type: "Grid",
        col: "col-md-3",
        data: [
          { type: "PatientDetails", employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
          { type: "CompanyDetails", companyDetails: props.companyDetails },
        ],
      }
    : null,
    {
      type: "Tab",
      col: `col-md-${props.hasEditAccess ? "9" : "12"}`,
      data: [
        {
          id: "patient",
          data: getTbBloodPatientQuestionnaireCardSections(),
        },
        {
          id: "provider",
          data: [
            {
              label: "Provider - Risk Assessment",
              fields: [
                {
                  label:
                    "Please answer the following questions to help us prepare for and expedite your visit.",
                  col: "col-12",
                  type: "Label",
                  labelWrap: false,
                },
                {
                  col: "col-12",
                  label: "",
                  defaultBtnLabel: "Set all to No",
                  type: "YesOrNoTable",
                  options: [
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ],
                  defaultValues: clinicianQuestions.reduce((acc, itm) => {
                    acc[itm.name] = false;
                    return acc;
                  }, {}),
                  list: clinicianQuestions,
                  failedValue: [true],
                },
                {
                  label: "RESULT: (one of the check boxes must be selected)",
                  col: "col-12",
                  type: "Label",
                },
                {
                  label:
                    "Individual has no risk factors or symptoms at this time – continue with annual TB testing.",
                  type: "Checkbox",
                  name: "no_risk_continue_normal",
                  id: "no_risk_continue_normal",
                  col: "col-md-6 col-12",
                  labelWrap: false,
                },
                {
                  label:
                    "Individual has identified risk factors associated with a possible TB exposure, should continue to self monitor for any symptoms and need for further testing.",
                  type: "Checkbox",
                  name: "risk_monitor_symptoms",
                  id: "risk_monitor_symptoms",
                  col: "col-md-6 col-12",
                  labelWrap: false,
                },
                {
                  label: "Printed Name",
                  type: "TextInput",
                  col: "col-md-6 col-12",
                  name: "clinician_printed_name",
                  id: "clinician_printed_name",
                  placeholder: "Printed Name",
                },
                {
                  label: "License Number & State",
                  type: "TextInput",
                  col: "col-md-6 col-12",
                  name: "clinician_license_number_state",
                  id: "clinician_license_number_state",
                  placeholder: "License Number & State ",
                },
                {
                  label: "Date",
                  type: "Date",
                  col: "col-md-6 col-12",
                  name: "clinician_signature_date",
                  id: "clinician_signature_date",
                },
                {
                  label: "Clinician Signature",
                  type: "Signature",
                  col: "col-md-6 col-12",
                  name: "clinician_signature_data",
                  id: "clinician_signature_data",
                },
              //   {
              //     label:'Status',
              //     type:'SelectList',
              //     // options:[],
              //     options:isSet(props.lookupsOptions['chartResult'],[]),
              //     name:'status',
              //     id:'status',
              // },
              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "ProviderSignOff",
                  col: "col-12",
                  fields: [
                    { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                    { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                    { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                    {
                      label: "Final Results",
                      type: "SelectList",
                      name: "status",
                      col: "col-12",
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Normal",
                          "Abnormal",
                          "Negative",
                          "Positive",
                          "Dispensed",
                          "Administered",
                          "Failed",
                          "Passed",
                          "Non-Negative",
                          "Cancelled",
                          "Inconclusive",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                    {
                      label: "Activity Status",
                      type: "SelectList",
                      name: "activity_status",
                      col: "col-12",
                      options: optionsToKeyValuePairs(
                        [
                          "Not Started",
                          "Pending",
                          "Pending Lab Confirmation",
                          "Pending MRO Confirmation",
                          "Ready for Review",
                          "Completed",
                          "Cancelled",
                        ],
                        false
                      ),
                      statusBasedColor: true,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: []
        },

      ],
    },
  ];
  const headers = [
    {
      type: "Tab",
      data: [
        {
          label: "Patient",
          id: "patient",
        },
        {
          label: "Provider",
          id: "provider",
        },
        {
          label: "Images",
          id: "Images",
        },

      ],
    },
  ];
  const defaultValue = {
    ...tbQuestionnaireFormDefaults,
    status: "Not Started",
    pulse_rate_result: "Not Started",
    blood_pressure_result: "Not Started",
    vission_result: "Not Started",
    urinalysis_result: "Not Started",
    medical_examiner_determination: "",
  };
  const buttons = {
    PDF: true,
  };
  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => computationRules(formData, key),
  };
};

const computationRules = (formData, key) => {
  const pulse = isSet(formData.pulse_rate, "");
  const systolic = isSet(formData.sitting_systolic, "");
  const diastolic = isSet(formData.sitting_diastolic, "");
  let returnResult = {};

  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");

  // If user changes any field while both status and activity_status are "Not Started",
  // move to Pending Result / In Progress
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (provider_signature exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }
  
  // Also check when provider_signature changes - if status is a completion status, update activity_status
  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }

  let pulseRateResult = "Not Started";
  if (pulse == "") {
    pulseRateResult = "Not Started";
  } else if (pulse >= 60 && pulse <= 100) {
    pulseRateResult = "Normal";
  } else if (pulse !== "") {
    pulseRateResult = "Abnormal";
  }

  let bloodPressureResult = "Not Started";
  if (systolic === "" && diastolic === "") {
    bloodPressureResult = "Not Started";
  } else if (systolic === "" || diastolic === "") {
    bloodPressureResult = "Pending";
  } else if (
    systolic < 0 ||
    systolic > 139 ||
    diastolic < 0 ||
    diastolic > 89
  ) {
    bloodPressureResult = "Abnormal";
  } else {
    bloodPressureResult = "Normal";
  }

  const spgr = isSet(formData.sp_gr, "");
  const protein = isSet(formData.protein, "");
  const blood = isSet(formData.blood, "");
  const sugar = isSet(formData.sugar, "");

  let urinariesResult = "Not Started";

  const sgNormalRange = { min: 1.002, max: 1.03 };
  const sgWithinNormalRange =
    spgr >= sgNormalRange.min && spgr <= sgNormalRange.max;

  // Check Protein, Blood, and Sugar levels
  const abnormalLevels = protein > 0 || blood > 0 || sugar > 0;

  // Determine status
  if (sgNormalRange === "" || protein === "" || blood === "" || sugar === 0) {
    urinariesResult = "Pending";
  } else if (sgWithinNormalRange && !abnormalLevels) {
    urinariesResult = "Normal";
  } else if (!sgWithinNormalRange || abnormalLevels) {
    urinariesResult = "Abnormal";
  } else {
    urinariesResult = "Pending";
  }

  let vissionResult = "Not Started";
  const wearing_corrective_lenses = isSet(
    formData["wearing_corrective_lenses"],
    null
  );
  const conditions =
    wearing_corrective_lenses === 0 ? "uncorrected" : "corrected";
  const horizontalRighteye = isSet(
    formData["horizontal_field_of_vision_right_eye"],
    ""
  );
  const horizontalLeftEye = isSet(
    formData["horizontal_field_of_vision_left_eye"],
    ""
  );
  const applicantRecoginize = isSet(
    formData["applicant_recognize_traffic_control_signals"],
    ""
  );
  const monocularvision = isSet(formData["monocular_vision"], "");

  if (wearing_corrective_lenses !== null) {
    const rightEye = isSet(formData["" + conditions + "_right_eye"], "");
    const bothEyes = isSet(formData["" + conditions + "_both_eyes"], "");
    const leftEye = isSet(formData["" + conditions + "_left_eye"], "");

    if (
      rightEye === "" ||
      bothEyes === "" ||
      leftEye === "" ||
      horizontalRighteye === "" ||
      horizontalLeftEye === ""
    ) {
      vissionResult = "Pending";
    } else if (
      rightEye > 40 ||
      bothEyes > 40 ||
      leftEye > 40 ||
      horizontalRighteye < 70 ||
      horizontalLeftEye < 70
    ) {
      vissionResult = "Failed";
    } else {
      vissionResult = "Passed";
    }
  } else {
    if (horizontalRighteye === "" || horizontalLeftEye === "") {
      vissionResult = "Pending";
    } else if (
      horizontalRighteye < 70 ||
      horizontalLeftEye < 70 ||
      applicantRecoginize === "No" ||
      monocularvision === "No"
    ) {
      vissionResult = "Failed";
    } else {
      vissionResult = "Passed";
    }
  }

  const earPrefixes = ["right_ear_", "left_ear_"];
  earPrefixes.forEach((earPrefix) => {
    const frequencies = [500, 1000, 2000, 3000, 4000, 6000, 8000];
    let total = 0;

    frequencies.forEach((frequency) => {
      const value = isSet(
        formData[`audiometric_test_results_${earPrefix}${frequency}_hz`],
        ""
      );
      total += Number(value);
    });
    const average = Math.ceil(total / frequencies.length);
    returnResult[`audiometric_test_results_${earPrefix}average`] = average;
  });

  const leftAverage =
    returnResult[`audiometric_test_results_right_ear_average`];
  const rightAverage =
    returnResult[`audiometric_test_results_left_ear_average`];
  const whisperTestRightEar = isSet(
    formData[`whisper_test_results_right_ear`],
    ""
  );
  const whisperTestLeftEar = isSet(
    formData[`whisper_test_results_left_ear`],
    ""
  );
  let hearingResult = "Not Started";
  if (
    Number(leftAverage) === 0 &&
    Number(rightAverage) === 0 &&
    whisperTestRightEar == "" &&
    whisperTestLeftEar === ""
  ) {
    hearingResult = "Not Started";
  } else if (
    (leftAverage !== "0.00" && leftAverage <= 40 && leftAverage !== 0) ||
    (rightAverage !== "0.00" && rightAverage <= 40 && rightAverage !== 0) ||
    whisperTestRightEar >= 5 ||
    whisperTestLeftEar >= 5
  ) {
    // console.log('ssss',leftAverage,rightAverage,whisperTestRightEar,whisperTestLeftEar);
    hearingResult = "Passed";
  } else if (
    (leftAverage === 0 || rightAverage === 0) &&
    (leftAverage > 40 || rightAverage > 40)
  ) {
    hearingResult = "Failed";
  } else if (
    leftAverage > 40 ||
    rightAverage > 40 ||
    (whisperTestRightEar < 5 && whisperTestLeftEar < 5)
  ) {
    hearingResult = "Failed";
  } else {
    hearingResult = "Pending";
  }
  returnResult = {
    ...returnResult,
    pulse_rate_result: pulseRateResult,
    blood_pressure_result: bloodPressureResult,
    vission_result: vissionResult,
    hearing_result: hearingResult,
    urinalysis_result: urinariesResult,
    certification_suggested_length: getCertificationLength(systolic, diastolic),
  };
  return returnResult;
};

// export const fetchProviderList = async (val, props, callback = () => {}) => {
//   const { employeeDetails } = props;
//   let optionArr = [];
//   try {
//     const data = await ProviderService.getProviderByClinicId(
//       employeeDetails.clinic_id,
//       { search: val }
//     );
//     isSet(data, []).map((item, itemIndex) => {
//       optionArr.push({
//         label: isSet(item.first_name, "") + " " + isSet(item.last_name, ""),
//         value: item.provider_id,
//         autoPopulateFields: {
//           medical_examiners_license_certificate_or_registration_number:
//             item.license,
//           national_registry_number: item.dol_registry_id,
//           medical_examiners_certificate_expiration_date:
//             item.dol_registry_expires,
//         },
//         data: item,
//         index: itemIndex,
//       });
//     });
//     callback(optionArr);
//   } catch (e) {}
//   return optionArr;
// };

export const getCertificationLength = (systolic, diastolic) => {
  if (systolic === "" || diastolic === "") {
    return "";
  }
  if (systolic < 140 && diastolic < 90) {
    return "2 year DOT Certificate";
  } else if (
    systolic >= 140 &&
    systolic <= 159 &&
    diastolic >= 90 &&
    diastolic <= 99
  ) {
    return "1 year DOT Certificate";
  } else if (
    systolic >= 160 &&
    systolic <= 179 &&
    diastolic >= 100 &&
    diastolic <= 109
  ) {
    return "3 month DOT Certificate";
  } else if (systolic >= 180 || diastolic >= 110) {
    return "Disqualified";
  } else {
    return "1 year DOT Certificate";
  }
};
